export const recipientCountKey = (broadcast) => {
  const { twilio_template: _twilioTemplate, ...rest } = broadcast || {};

  return JSON.stringify(rest);
};
